import { render } from "./howItWorksModel.vue?vue&type=template&id=32f53d1a&scoped=true"
import script from "./howItWorksModel.vue?vue&type=script&lang=js"
export * from "./howItWorksModel.vue?vue&type=script&lang=js"

import "./howItWorksModel.vue?vue&type=style&index=0&id=32f53d1a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32f53d1a"]])

export default __exports__